import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {Team} from "../interface/team";

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getTeamsByCurrentMember(): Observable<Team[]> {
    return this.http.get<Team[]>(`${this.apiUrl}/teams/involved`);
  }

  getAllTeamsByCurrentMember(): Observable<Team[]> {
    return this.http.get<Team[]>(`${this.apiUrl}/teams/all-my-teams`);
  }

  getCurrentUserTeam(): Observable<Team> {
    return this.http.get<Team>(`${this.apiUrl}/teams/my-team`);
  }
  isCurrentUserOwnerTeam(): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/teams/owner`);
  }

  updateTeamName(teamId: number, name: string): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/teams/${teamId}`, {name: name});
  }

  deleteCardFromTeam(cardId: string): Observable<any> {
    const params = new HttpParams().set('id', cardId);
    return this.http.delete(`${this.apiUrl}/teams/card/delete`, {params});
  }

  updateRequestAllowed(teamId: number, requestAllowed: boolean): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/teams/change-request_allowed/${teamId}`, requestAllowed);
  }

  getAllTeams(): Observable<Team[]> {
    return this.http.get<Team[]>(`${this.apiUrl}/teams/all`);
  }
}
